import { styled } from '@mui/material'
import { GetStaticProps } from 'next'

import { convertToComponent } from '@ecm/data/Contentful'
import { Snippet } from '@ecm/data/Snippet'
import { runEff } from '@ecm/effect'
import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

type TermsOfServicePageProps = {
  terms: Snippet
  className?: string
}

const TermsOfServicePage = styled(({ terms, className }: TermsOfServicePageProps) => (
  <DefaultLayout hideFinalCta seoPage="mail-vendor-general-terms" className={className}>
    <PlainHeader title="Mail vendor general terms" />
    <MainContainer sx={{ paddingY: '4em' }}>
      {terms && convertToComponent(terms.content, 'p3')}
    </MainContainer>
  </DefaultLayout>
))({
  ol: {
    counterReset: 'item',
    li: {
      '&:before': {
        content: `counters(item, ".") ". "`,
        counterIncrement: 'item',
        display: 'table-cell',
        paddingRight: '0.5em',
      },
      display: 'table',
    },
  },
})

export default TermsOfServicePage

export const getStaticProps: GetStaticProps = async () => {
  const terms = await runEff(eff => eff.getSnippet('mail-vendor-general-terms'))

  return { props: { terms } }
}
